import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'
import TextField from '@mui/material/TextField'

export const CloseModalIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content;
`

export const TaskLinkModalContainer = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  position: relative;
  height: 363px;
  padding: 40px;
  width: 768px;
`

export const TaskLinkModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`

export const AddLink = styled.label`
  ${typography.up2.semiBoldSans}
`

export const LinkTextField = styled(TextField)`
  width: 100%;
`

export const AddLinkActions = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const AddLinkButtons = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 20px;
  width: 100%;
`
